// =============================
// Imports
// =============================

import styled, { css } from 'styled-components';

// =============================
// Styles
// =============================

export const Languages = styled.div`
  align-items: center;
  bottom: 3rem;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  font-size: 1.4rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  left: 3rem;
  margin-right: auto;
  position: fixed;
`;

export const Lang = styled.div`
  cursor: pointer;
  margin: 0.4rem;
  opacity: 0.5;
  position: relative;
  text-transform: capitalize;
  transition: opacity ${({ theme }) => theme.transition.medium};

  &:after {
    background-color: ${({ theme }) => theme.colors.primary};
    content: '';
    height: 0.2rem;
    left: 0;
    position: absolute;
    transition: transform ${({ theme }) => theme.transition.fast}
      ${({ theme }) => theme.transitionTiming.easeInOut};
    transform: scaleX(0);
    transform-origin: left;
    top: 100%;
    width: 100%;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    opacity: 1;

    &:after {
      transform: scaleX(1);
    }
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${({ selected }) => selected
    && css`
      opacity: 1;
    `};
`;
